import React from 'react';

import type {IconProps} from '../types';
import {colourMap, sizesMap} from '../utils/iconProperties';

const TickCircleIcon = ({
  size = 'small',
  colour = 'textPrimary',
  alt,
}: IconProps): JSX.Element => (
  <svg
    aria-hidden={!alt ? true : undefined}
    aria-label={alt}
    role={alt ? 'img' : undefined}
    width={sizesMap[size]}
    height={sizesMap[size]}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      d='M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12Zm-4.26-3.352a.888.888 0 0 0 0-1.255l-1.134-1.134a.891.891 0 0 0-1.257 0l-8.339 8.33-2.36-2.358a.89.89 0 0 0-1.256 0L4.26 13.365a.889.889 0 0 0 0 1.255l4.124 4.12a.89.89 0 0 0 1.256 0l1.135-1.133a.845.845 0 0 0 .033-.036l.028-.025 8.905-8.898Z'
      fill={colourMap[colour]}
    />
  </svg>
);

export default TickCircleIcon;
